import { type FeatureModule } from '@store/features/types';

/**
 * Reports feature module definition.
 *
 * Pure API feature: endpoints are injected into baseApi by ./api.ts, so no
 * reducers, persistence, or middleware are needed.
 */
export const reportsFeature: FeatureModule = {
  id: 'reports',
  name: 'Reports',
  dependencies: [],
  reducers: {},
  middleware: [],
};
